import apiClient from '../utils/api/ApiClient';
import { API_CONFIG, API_ENDPOINTS } from '../constants/api.constants';
import type {
    RebuildClosingStockApiResponse,
    UpdateTodayStockCountApiResponse,
} from '../types/api.types';

const STOCK_OPS_CONFIG = (storeBrandId: string) => ({
    headers: { 'X-Store-Brand-Id': storeBrandId },
    timeout: API_CONFIG.STOCK_OPS_TIMEOUT_MS,
});

export const rebuildClosingStock = (
    storeId: string,
    storeBrandId: string,
    fromDate: string,
    toDate: string
): Promise<RebuildClosingStockApiResponse> =>
    apiClient.post<RebuildClosingStockApiResponse>(
        API_ENDPOINTS.STORE_MANAGEMENT.REBUILD_CLOSING_STOCK(storeId),
        { fromDate, toDate },
        STOCK_OPS_CONFIG(storeBrandId)
    );

export const updateTodayStockCount = (
    storeId: string,
    storeBrandId: string
): Promise<UpdateTodayStockCountApiResponse> =>
    apiClient.post<UpdateTodayStockCountApiResponse>(
        API_ENDPOINTS.STORE_MANAGEMENT.UPDATE_TODAY_STOCK_COUNT(storeId),
        {},
        STOCK_OPS_CONFIG(storeBrandId)
    );
